import { isBGDark } from './isBGDark';
import { makeRgbBg } from './makeRgbBg';
// import hexRgb from 'hxex-rgb';
import hexToRgb from 'hex-to-rgb';

function remHexHash  ( hexhash ) {
    return hexhash.replace('#','')
}

function textColor ( color ){
    return isBGDark(makeRgbBg(hexToRgb(`#${color}`))) ? 'white' : 'black';
}

export { remHexHash, textColor };


// WEBPACK FOOTER //
// ./src/utilis/index.js